import { api } from "@/lib/api";

// The documents lenders ask for first. Labels are what everyone sees, so keep them plain English.
const DOCS = {
  statements: { label: "Last 6 months' bank statements", why: "Shows your cash flow — the first thing every lender checks", icon: "bank" },
  accounts: { label: "Latest filed accounts", why: "Turnover and profit at a glance", icon: "chart" },
  id: { label: "Director photo ID", why: "Passport or driving licence for the main director", icon: "id" },
  debtors: { label: "Aged debtor list", why: "Who owes you and for how long — what invoice lenders fund against", icon: "list" },
  cards: { label: "Card terminal statements", why: "Your last 3–6 months of card takings", icon: "card" },
  property: { label: "Property details or valuation", why: "Address, value and any existing mortgage on it", icon: "home" },
  works: { label: "Schedule of works and costs", why: "What's being built, what it costs and what it's worth when done", icon: "works" },
  asset: { label: "Asset invoice or quote", why: "The quote or invoice for what you're buying", icon: "receipt" },
  plan: { label: "Business plan or forecast", why: "Where the business is heading and how the money helps", icon: "chart" },
  deck: { label: "Pitch deck", why: "The story investors read first", icon: "deck" },
  vat: { label: "VAT returns", why: "Your last four quarters", icon: "receipt" },
  rd: { label: "R&D claim or report", why: "The claim the advance is lent against", icon: "doc" },
  tax: { label: "Corporation tax bill", why: "The bill the loan will pay", icon: "receipt" },
};

const BY_TYPE = [
  [/invoice|factoring/i, ["statements", "debtors", "accounts"]],
  [/merchant cash/i, ["statements", "cards", "id"]],
  [/development|refurbishment/i, ["works", "statements", "id"]],
  [/mortgage|bridging|auction/i, ["statements", "property", "id"]],
  [/asset|hire purchase|lease/i, ["statements", "asset", "accounts"]],
  [/equity|series|angel|venture/i, ["deck", "plan", "accounts"]],
  [/r&d/i, ["statements", "rd", "accounts"]],
  [/vat loan/i, ["statements", "vat", "id"]],
  [/corporation tax/i, ["statements", "tax", "accounts"]],
];

/** The three documents for a finance type — the everyday three until a type is picked. */
export function fastDocsFor(financeType) {
  const hit = BY_TYPE.find(([re]) => re.test(financeType || ""));
  return (hit ? hit[1] : ["statements", "accounts", "id"]).map((k) => DOCS[k]);
}

/** True while any of the three still has nothing in it. */
export const fastDocsMissing = (financeType, files) =>
  fastDocsFor(financeType).some((d) => !(files || []).some((f) => f.label === d.label));

/** Files outside the current three (untagged, or tagged for a set the finance type no longer uses) — the 'anything else' list. */
export function otherFiles(financeType, files) {
  const slots = fastDocsFor(financeType).map((d) => d.label);
  const isSlot = (f) => slots.includes(f.label);
  return { others: (files || []).filter((f) => !isSlot(f)), keep: (fs) => [...(files || []).filter(isSlot), ...fs] };
}

/** One file up to `path`, with its slot label; reports progress 0–100. */
export async function sendFile(path, file, params, onProgress) {
  const fd = new FormData();
  fd.append("file", file);
  const r = await api.post(path, fd, {
    params, headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress: (ev) => onProgress?.(ev.total ? Math.round((ev.loaded / ev.total) * 100) : 60),
  });
  return r.data;
}
